import makeId from "./make-id";

export default function (statementTemplate, data = null, replaceString = '--STATEMENT-ID--') {
    const statementHtml = $(statementTemplate).html();
    const $statement = $(statementHtml.replaceAll(replaceString, makeId(8)));

    if (!$.isEmptyObject(data)) {
        $statement.find('[data-name-male-male]').val(data.male.male);
        $statement.find('[data-name-male-female]').val(data.male.female);
        $statement.find('[data-name-female-male]').val(data.female.male);
        $statement.find('[data-name-female-female]').val(data.female.female);
    }

    return $statement;
}
